import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getViolations } from "src/API/CrewScheduleErrors";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { CrewScheduleGL } from "./gl/CrewScheduleGL";

interface ICrewScheduleViolationsProps {
  lastUpdatedCrew: number;
  crewSchedGL: CrewScheduleGL | null;
  start: () => void;
  isAnimating: boolean;
}

export const CrewScheduleViolations = (props: ICrewScheduleViolationsProps): null => {
  const { crewSchedGL, lastUpdatedCrew, start } = props;
  const dispatch = useDispatch();
  const crewViolations = useSelector((state: IRootState) => state.crewSchedule.crewViolations);
  const loadedViolations = useSelector((state: IRootState) => state.crewSchedule.loadedViolations);
  const hideDropOffHours = useSelector((state: IRootState) => state.crewSchedule.hideDropOffHours);

  //!! I think this is what we want to check on if the loadedViolations has happened, not if there is anything in redux
  useEffect(() => {
    if (crewSchedGL && !loadedViolations) {
      dispatch(getViolations());
    }
  }, [crewSchedGL, loadedViolations, dispatch]);
  useEffect(() => {
    if (!crewSchedGL || !crewViolations || !loadedViolations) {
      return;
    }
    setTimeout(() => {
      crewSchedGL.updateViolations(crewViolations);
      start();
    }, 0);
  }, [crewViolations, lastUpdatedCrew, crewSchedGL, start, loadedViolations]);

  useEffect(() => {
    if (!crewSchedGL) {
      return;
    }

    crewSchedGL.setHideDropOffHours(hideDropOffHours);
    start();
  }, [crewSchedGL, hideDropOffHours, start]);
  return null;
};
